<template>
  <div class="download-overlay">
    <div class="backdrop"></div>
    <div class="content">
      <div v-if="url == null">
        <img src="/images/loader.gif" alt="Processing…" style="width: 25px; height: 25px; display: inline-block; margin: 10px" />

        {{ I18n.t("preparing_image_for_download") }}
      </div>

      <div v-if="url != null">
        <button class="close-btn" v-on:click="close" :title='I18n.t("modal_close")'>
          <i class="fas fa-times"></i>
        </button>
        <p style="margin-bottom: 0;">
          <button class="btn btn-primary btn-lg mb-1" v-on:click="shareImage" v-if="shareSupported" style="width: 100%;">
            <i class="fas fa-share-alt"></i>
            {{ I18n.t("share_image") }}
          </button>
          <a v-bind:href="url" v-bind:class="`btn ${shareSupported ? 'btn-outline-primary' : 'btn-primary btn-lg'}`" target="_blank" style="width: 100%" v-bind:download="canSupportDownloadAttribute ? filename : null" v-on:click="download">
            <i class="fas fa-download"></i> {{ I18n.t("download_image") }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
import blobToBase64 from '../src/blob_to_base64';

const isUCBrowser = navigator.userAgent.indexOf(' UCBrowser/') >= 0;

function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

export default {
  props: {
    url: String,
    filename: String,
    blob: Blob,
    locale: String,
  },
  data() {
    return {
      canSupportDownloadAttribute: !isUCBrowser,
    };
  },
  computed: {
    file() {
      if(this.blob) {
        return new File([this.blob], this.filename, {
          type: "image/png",
          lastModified: new Date().getTime()
        });
      }
      return null;
    },
    shareSupported() {
      return this.file && (window.mobile_app || navigator.canShare && navigator.canShare({files: [this.file]}));
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    download(e) {
      // track click
      window.track("Images", "download_from_editor", "Download from Editor");
      if(window.hj) window.hj('trigger', 'editor_download');

      // don't show editor close warning anymore
      this.$emit("downloaded");

      // modern browsers like FF and Chrome just have a blob
      var blob = this.blob;

      // Edge and others have no blob
      if(!blob) {
        // sometimes they use a data URI, that we can convert to a blob
        var dataUrlRegexp = /^data:image\/png;base64,/;
        var isDataUrl = this.url.match(dataUrlRegexp);

        if(isDataUrl) {
          blob = base64toBlob(this.url.replace(dataUrlRegexp, ''), "image/png");
        }
      }

      if(window.mobile_app) {
        e.preventDefault();
        blobToBase64(blob).then((base64) => {
          window.mobile_app.downloadBase64(this.filename, base64.replace(/^data:image\/png;base64,/, ''));
        });
        return;
      }

      var ua = window.navigator.userAgent;
      var isiOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);

      // if we have a blob from somewhere, download it with FileSaver.js
      if(blob && !isiOS && !isUCBrowser) {
        e.preventDefault();
        saveAs(blob, this.filename);
      }
      // otherwise, just open whatever URL was generated in a new window
      // (potentially trigger download if browser supports a[download])
    },
    shareImage() {
      // track click
      window.track("Images", "share_from_editor", "Share from Editor");
      if(window.hj) window.hj('trigger', 'editor_download');

      if(window.mobile_app) {
        blobToBase64(this.blob).then((base64) => {
          window.mobile_app.shareBase64(this.filename, base64);
        });
        return;
      }
      navigator.share({
        files: [this.file],
        text: 'www.remove.bg'
      }).then(() => {
        //alert("shared");
      }).catch((error) => {
        //alert(error);
      });
    }
  }
}
</script>

<style scoped>
  .download-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 19000;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .download-overlay .backdrop {
    background: rgba(0,0,0,0.5);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 19020;
  }
  .download-overlay .content {
    background: #fff;
    position: relative;
    z-index: 19050;
    padding: 15px;
    max-width: 345px;
    border-radius: 3px;
  }
  .close-btn {
    position: absolute;
    right: -20px;
    top: -20px;
    background: transparent;
    border: 1px solid #595959;
    color: #595959;
    font-size: 16px;
    width: 34px;
    height: 34px;
    background: #fff;
    padding: 8px;
    margin: 0;
    border-radius: 19px;
    line-height: 1;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  .close-btn:hover, .close-btn:focus {
    background: #eee;
  }
</style>
